export function sortByKey<T>(
  array: T[],
  key: keyof T
): T[] {
  return [...array].sort((a, b) => {
    const valueA = String(a[key] ?? "").toLowerCase().trim();
    const valueB = String(b[key] ?? "").toLowerCase().trim();

    return valueA.localeCompare(valueB, undefined, {
      sensitivity: "base",
      numeric: true,
    });
  });
}